import React from 'react';
import { ReactComponent as ShieldIcon } from '../../../icons/prequal_shield.svg';
import { ReactComponent as CheckIcon } from '../../../icons/prequal_check.svg';
import { ReactComponent as BoatIcon } from '../../../icons/prequal_boat.svg';
import { ReactComponent as HandshakeIcon } from '../../../icons/prequal_handshake.svg';
import { ReactComponent as MedalIcon } from '../../../icons/prequal_medal.svg';
import { ReactComponent as StarIcon } from '../../../icons/prequal_star.svg';
import { ReactComponent as CurrencyIcon } from '../../../icons/prequal_currency.svg';
import styles from './FooterCard.module.scss';

export type FooterCardIconType =
  | 'shield'
  | 'check'
  | 'boat'
  | 'handshake'
  | 'medal'
  | 'star'
  | 'dollarSign';

export type FooterCardItem = {
  text: React.ReactNode | 'privacy-policy';
};

const DEFAULT_TITLE = 'Your security is our top priority';
const PrivacyPolicyLink = (
  <>
    We won't sell your information. Read our{' '}
    <a href="https://www.tridentfunding.com/privacy-policy/" target="_blank" rel="noreferrer">
      Privacy Notice.
    </a>
  </>
);

const DEFAULT_ITEMS: FooterCardItem[] = [
  { text: 'privacy-policy' },
  { text: 'No Impact to your credit score!' },
];

const DEFAULT_FIRST_ITEM: FooterCardItem = {
  text: "We'll encrypt your information to keep it secure.",
};

const DEFAULT_ICON: FooterCardIconType = 'shield';

const iconMap: Record<FooterCardIconType, React.FC<React.SVGProps<SVGSVGElement>>> = {
  shield: ShieldIcon,
  check: CheckIcon,
  boat: BoatIcon,
  handshake: HandshakeIcon,
  medal: MedalIcon,
  star: StarIcon,
  dollarSign: CurrencyIcon,
};

type Props = {
  showFirstItem?: boolean;
  title?: string;
  items?: FooterCardItem[];
  icon?: FooterCardIconType;
};

const FooterCard: React.FC<Props> = (props) => {
  const { showFirstItem = false, title, items, icon } = props;

  const displayTitle = title ?? DEFAULT_TITLE;
  const displayIcon = icon ?? DEFAULT_ICON;
  const IconComponent = iconMap[displayIcon];

  const displayItems: FooterCardItem[] = [];
  if (showFirstItem) {
    displayItems.push(DEFAULT_FIRST_ITEM);
  }

  displayItems.push(...(items ?? DEFAULT_ITEMS));

  return (
    <div className={styles.footerContainer}>
      <div className="content">
        <div className="text-container">
          <div className="title">{displayTitle}</div>
          {displayItems.map((item) => (
            <div
              key={typeof item.text === 'string' ? item.text : String(item.text)}
              className="item"
            >
              <div className="check">
                <CheckIcon />
              </div>
              <div>{item.text === 'privacy-policy' ? PrivacyPolicyLink : item.text}</div>
            </div>
          ))}
        </div>
        <div className="icon">
          <IconComponent />
        </div>
      </div>
    </div>
  );
};

export default FooterCard;
